module.exports = __webpack_public_path__ + "img/62.95b422d1.webp";